import styled from "styled-components";
import { FlexWrapR } from "./common/CommonLayout";
import { colors } from "styles/global-styles";

const StepTitleHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    font-family: var(--font-nanumSquare-acB);
    color: ${({ theme }) => theme.newTheme.text.mainText};
    
    h3 > p {
        font-size: 1.375rem;
    }

`;

// 회원가입 페이지: 상단 타이틀 및 페이지수
export function SignHeader({title1, title2, page}: {title1:string, title2:string, page:number}) {
    return (
        <StepTitleHeader>
            <h3>
                <p>{title1}</p>
                <p>{title2}</p>
            </h3>
            <FlexWrapR $gap="0.25rem">
                <span>{page}</span>
                <span style={{color: colors.gray}}>/</span>
                <span style={{color: colors.gray}}>5</span>
            </FlexWrapR>
        </StepTitleHeader>
    );
}